import DescriptionChoiceContainer from '@components/atoms/container/descriptionChoiceContainer';
import ChannelChoiceDescription from '@components/atoms/text/channelChoiceDescription';
import ChannelChoiceTitle from '@components/atoms/text/channelChoiceTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';

export default function DescriptionChoice() {
  return (
    <DescriptionChoiceContainer>
      <ChannelChoiceTitle>
        {TranslationManager.get('PAGES.CHANNELS_CHOICE.TITLE')}
      </ChannelChoiceTitle>
      <ChannelChoiceDescription
        dangerouslySetInnerHTML={{
          __html: TranslationManager.get('PAGES.CHANNELS_CHOICE.DESCRIPTION'),
        }}
      ></ChannelChoiceDescription>
    </DescriptionChoiceContainer>
  );
}
